<template>
  <div :class="theme == 2 ? 'black' : ''">
    <img v-if="theme == 2" src="../assets/icon12.png" alt="" />
    <img v-else src="../assets/icon11.png" alt="" />
    <p>
      订单支付成功，您已解锁服务<br />
      客服人员正在飞速为您开通权限
    </p>
    <div class="sub-boot">
      <van-button type="info" color="#F44336" block @click="goOrder"
        >查看订单</van-button
      >
      <van-button
        type="info"
        plain
        style="margin-top: 0.33rem"
        color="#F44336"
        block
        @click="goProductInfo"
        >完成</van-button
      >
    </div>
  </div>
</template>

<script>
import { NavBar, Image, Button, Toast } from "vant";
import {
  connectWebViewJavascriptBridge,
  getBrowserUserAgent,
} from "@/utils/utility";
var userAgent = getBrowserUserAgent();
var dsBridge = require("dsbridge");
// var picHost = process.env.VUE_APP_PIC_BASE_URL;
export default {
  components: {
    [NavBar.name]: NavBar,
    [Image.name]: Image,
    [Button.name]: Button,
    [Toast.name]: Toast,
  },
  data() {
    return {
      theme: 1,
    };
  },
  mounted() {
    var that = this;
    if (userAgent.android) {
      dsBridge.reg("changeTheme", function (responseData) {
        responseData = JSON.parse(responseData);
        that.theme = responseData;
        sessionStorage.setItem("theme", responseData);
      });
    } else {
      connectWebViewJavascriptBridge(() => {
        var that = this;
        window.WebViewJavascriptBridge.registerHandler(
          "changeTheme",
          function (responseData) {
            responseData = JSON.parse(responseData);
            that.theme = responseData;
            sessionStorage.setItem("theme", responseData);
          }
        );
      });
    }
    this.$once("hook:beforeDestroy", () => {
      clearInterval(this.timer);
    });
  },
  created() {
    if (sessionStorage.getItem("theme") == 2) {
      this.theme = 2;
    } else {
      this.theme = 1;
    }
  },
  methods: {
    goOrder() {
      setTimeout(() => {
        this.$router.replace({ path: "/order" });
      }, 100);
      // let backlen = window.history.length - 1;
      // window.history.go(-backlen);

      // location.reload();
      // var dataUrl =
      //   picHost +
      //   "/mall/order?token=" +
      //   sessionStorage.getItem("Access-Token") +
      //   "&webkey=" +
      //   sessionStorage.getItem("webkey") +
      //   "&userId=" +
      //   sessionStorage.getItem("userId")
      // var param = {
      //   action: "h5",
      //   param: {
      //     url: dataUrl,
      //   },
      // };
      // if (userAgent.ios) {
      //   window.WebViewJavascriptBridge.callHandler(
      //     "webPushNative",
      //     param,
      //     function (responseData) {}
      //   );
      // } else if (userAgent.android) {
      //   dsBridge.call("webPushNative", param);
      // } else {
      //   window.location.href = dataUrl;
      // }

      //   if (userAgent.android) {
      //     dsBridge.call("closeContainer");
      //   } else {
      //     window.WebViewJavascriptBridge.callHandler(
      //       "closeContainer",
      //       function (responseData) {}
      //     );
      //   }
    },
    goProductInfo() {
      var productId = sessionStorage.getItem("productId");
      var type = sessionStorage.getItem("producttype");
      if (productId) {
        var query = { type: type, id: productId, theme: this.theme };

        location.reload();
        setTimeout(() => {
          this.$router.replace({ path: "/product_info", query: query });
        }, 100);
        let backlen = window.history.length - 1;
        window.history.go(-backlen);
      } else {
        let backlen = window.history.length - 1;
        window.history.go(-backlen);
      }

      // var dataUrl =
      //   picHost +
      //   "/mall/product_info?token=" +
      //   sessionStorage.getItem("Access-Token") +
      //   "&webkey=" +
      //   sessionStorage.getItem("webkey") +
      //   "&userId=" +
      //   sessionStorage.getItem("userId") +
      //   "&id=" +
      //   productId +
      //   "&type=" +
      //   type
      // var param = {
      //   action: "h5",
      //   param: {
      //     url: dataUrl,
      //   },
      // };
      // if (userAgent.ios) {
      //   window.WebViewJavascriptBridge.callHandler(
      //     "webPushNative",
      //     param,
      //     function (responseData) {}
      //   );
      // } else if (userAgent.android) {
      //   dsBridge.call("webPushNative", param);
      // } else {
      //   window.location.href = dataUrl;
      // }

      //   if (userAgent.android) {
      //     dsBridge.call("closeContainer");
      //   } else {
      //     window.WebViewJavascriptBridge.callHandler(
      //       "closeContainer",
      //       function (responseData) {}
      //     );
      //   }
    },
  },
};
</script>

<style lang="less" scoped>
img {
  width: 1.54rem;
  height: 1.8rem;
  padding: 1.91rem 0 0.25rem 2.98rem;
}
p {
  text-align: center;
  font-size: 0.36rem;
  color: #394259;
  line-height: 0.48rem;
}
.sub-boot {
  padding: 1.44rem 1.04rem 0 1.07rem;
  .van-button--plain {
    background: #fefaf9;
  }
}
.black {
  height: 100vh;
  background: #12161f;
  p {
    color: #f0f1f5;
  }
  .sub-boot {
    .van-button--plain {
      background: #12161f;
    }
  }
}
</style>